import { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ProductBulkOf } from 'api/products/_requests';

interface BulkOfferProps {
  bulkOffer: ProductBulkOf[];
  setBulkOffer: React.Dispatch<React.SetStateAction<ProductBulkOf[]>>;
}

const ProductBulkOffer = ({ bulkOffer, setBulkOffer }: BulkOfferProps) => {
  const [errors, setErrors] = useState<{ quantity?: string; price?: string }[]>(
    () => bulkOffer.map(() => ({}))
  );

  const handleChange = (
    index: number,
    field: keyof ProductBulkOf,
    value: string
  ) => {
    const updated = [...bulkOffer];
    updated[index][field] = value === '' ? 0 : Number(value);
    setBulkOffer(updated);

    const newErrors = [...errors];
    newErrors[index] = {};

    if (!updated[index].quantity) {
      newErrors[index].quantity = 'Enter quantity';
    }
    if (!updated[index].price) {
      newErrors[index].price = 'Enter price';
    }

    setErrors(newErrors);
  };

  const addRow = () => {
    setBulkOffer(prev => [...prev, { quantity: 0, price: 0 }]);
    setErrors(prev => [...prev, {}]);
  };

  const removeRow = (index: number) => {
    setBulkOffer(prev => prev.filter((_, i) => i !== index));
    setErrors(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      {bulkOffer.map((row, i) => (
        <Row key={i} className="g-2 mb-2 align-items-start">
          <Col xs={12} md={5}>
            <Form.Control
              type="number"
              placeholder="Quantity"
              value={row.quantity === 0 ? '' : row.quantity}
              isInvalid={!!errors[i]?.quantity}
              onChange={e => handleChange(i, 'quantity', e.target.value)}
            />
            <Form.Control.Feedback type="invalid">
              {errors[i]?.quantity}
            </Form.Control.Feedback>
          </Col>

          <Col xs={12} md={5}>
            <Form.Control
              type="number"
              placeholder="Price / pc"
              value={row.price === 0 ? '' : row.price}
              isInvalid={!!errors[i]?.price}
              onChange={e => handleChange(i, 'price', e.target.value)}
            />
            <Form.Control.Feedback type="invalid">
              {errors[i]?.price}
            </Form.Control.Feedback>
          </Col>

          <Col xs={12} md={2} className="text-md-end">
            <Button
              variant="outline-danger"
              type="button"
              className="w-100 w-md-auto"
              onClick={() => removeRow(i)}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
          </Col>
        </Row>
      ))}

      <Button variant="outline-primary" type="button" onClick={addRow}>
        <FontAwesomeIcon icon={faPlus} className="me-1" />
        Add Bulk Offer
      </Button>
    </>
  );
};

export default ProductBulkOffer;
